import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  ExclamationTriangleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import OrderDetailsInfo from "./OrderDetailsInfo";
import { UilShoppingCart } from "@iconscout/react-unicons";

const products = [
  {
    orderNumber: "OID-SCS1-000001",
    orderDate: "11/22/2023 11:23:27 AM",
    status: "Scheduled",
    scheduleDate: "2023-11-22T11:08:00",
    invoiceNo: null,
    actualDeliveryDate: "0001-01-01T00:00:00",
    netTotal: 130.1,
    grossTotal: 123.9,
    totalDiscount: 0,
    totalTax: 6.2,
    totalItems: 2,
    orderItems: [
      {
        itemCode: "9000452",
        itemName: "200ML*24 SRNK(S)",
        uom: "PAC",
        quantity: 10,
        price: 8.1,
        itemDiscount: 0,
        itemTax: 4.05,
      },
      {
        itemCode: "9000463",
        itemName: "1500 ML*6 SRNK",
        uom: "PAC",
        quantity: 10,
        price: 4.29,
        itemDiscount: 0,
        itemTax: 2.15,
      },
    ],
  },
];

const OrderDetails = ({ showPopUp, onClose, orderInfo, customerAdderss }) => {
  return (
    <Transition.Root show={showPopUp} as={Fragment}>
      <Dialog as="div" className="relative z-[22]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-[22] w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-textWhite px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
                <div className="absolute right-0 top-0 pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <UilShoppingCart
                      className="h-6 w-6 text-red-600"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-base font-semibold leading-6 text-gray-900"
                    >
                      Order Details
                    </Dialog.Title>
                    <div className="mt-2">
                      {orderInfo && (
                        <OrderDetailsInfo
                          customerAdderss={customerAdderss}
                          orderInfo={orderInfo}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="mt-2 sm:mt-2 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={onClose}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default OrderDetails;
